import t, { forwardRef as q, useState as g, useRef as G, useEffect as H, useCallback as a, useImperativeHandle as M } from "react";
import N from "classnames";
import { Icon as h } from "./index10.mjs";
import o from "./index275.mjs";
import "./index2.mjs";
import "./index222.mjs";
import "./index5.mjs";
import "./index6.mjs";
import "./index7.mjs";
import "./index8.mjs";
import "dompurify";
import "./index11.mjs";
import "./index12.mjs";
import "./index13.mjs";
import "./index14.mjs";
import "./index241.mjs";
import "./index242.mjs";
import "./index27.mjs";
import "./index253.mjs";
import "xss";
import "react-popper";
import "./index243.mjs";
import "./index18.mjs";
import "./index19.mjs";
import "./index20.mjs";
import "./index21.mjs";
import "./index250.mjs";
import "./index251.mjs";
import "./index25.mjs";
import "./index26.mjs";
import "./index28.mjs";
import "./index29.mjs";
import { I18n as O } from "./index128.mjs";
import "./index31.mjs";
import "./index267.mjs";
import "./index33.mjs";
import "./index34.mjs";
import "./index272.mjs";
import "./index273.mjs";
import "./index39.mjs";
import "./index40.mjs";
import "./index41.mjs";
import "./index42.mjs";
import "./index43.mjs";
import "./index44.mjs";
import "./index45.mjs";
import "./index46.mjs";
import "./index276.mjs";
import "lodash.noop";
import "./index277.mjs";
import "./index278.mjs";
import "react-input-mask";
import "date-fns";
import "date-fns-tz";
import "./index279.mjs";
import "./index280.mjs";
import "./index281.mjs";
import "./index282.mjs";
import "./index50.mjs";
import "./index51.mjs";
import "./index52.mjs";
import "./index283.mjs";
import "./index263.mjs";
import "./index284.mjs";
import "./index54.mjs";
import "./index55.mjs";
import "./index285.mjs";
import "./index230.mjs";
import "./index57.mjs";
import "./index58.mjs";
import "./index286.mjs";
import "./index287.mjs";
import "./index288.mjs";
import "./index289.mjs";
import "./index290.mjs";
import "./index291.mjs";
import "./index292.mjs";
import "react-dom/server";
import "./index293.mjs";
import "lodash.uniqueid";
import "./index72.mjs";
import "./index294.mjs";
import "./index63.mjs";
import "./index295.mjs";
import "./index296.mjs";
import "./index297.mjs";
import "./index298.mjs";
import "./index66.mjs";
import "./index67.mjs";
import "./index68.mjs";
import "./index69.mjs";
import "./index70.mjs";
import "./index71.mjs";
import "./index73.mjs";
import "./index74.mjs";
import "./index299.mjs";
import "./index300.mjs";
import "./index301.mjs";
import "lodash.snakecase";
import "./index302.mjs";
import "./index77.mjs";
import "./index303.mjs";
import "./index304.mjs";
import "./index81.mjs";
import "./index305.mjs";
import "./index306.mjs";
import "./index307.mjs";
import "./index308.mjs";
import "./index309.mjs";
import "./index153.mjs";
import "./index310.mjs";
import "./index311.mjs";
import "./index312.mjs";
import "./index313.mjs";
import "./index85.mjs";
import "./index86.mjs";
import "./index87.mjs";
import "./index314.mjs";
import "./index315.mjs";
import "./index89.mjs";
import "./index316.mjs";
import "./index317.mjs";
import "./index318.mjs";
import "lodash.debounce";
import "./index91.mjs";
import "./index319.mjs";
import "./index320.mjs";
import "./index321.mjs";
import "./index322.mjs";
import "./index323.mjs";
import "./index324.mjs";
import "./index325.mjs";
import "./index326.mjs";
import "./index327.mjs";
import "./index328.mjs";
import "./index329.mjs";
import "./index330.mjs";
import "./index331.mjs";
import "./index332.mjs";
import "./index333.mjs";
import "./index334.mjs";
import "react-youtube";
import "./index335.mjs";
import "./index336.mjs";
import "./index337.mjs";
import "./index338.mjs";
import "./index339.mjs";
import "./index340.mjs";
import "./index341.mjs";
import "./index110.mjs";
import "./index342.mjs";
import "./index343.mjs";
import "./index344.mjs";
import "flat";
import "./index345.mjs";
import "./index346.mjs";
import "libphonenumber-js";
import "./index347.mjs";
import "./index348.mjs";
import "./index115.mjs";
import "./index349.mjs";
import "./index117.mjs";
import "./index118.mjs";
import "./index119.mjs";
import "./index350.mjs";
import "./index351.mjs";
import "./index352.mjs";
import "./index353.mjs";
import "./index354.mjs";
import "./index138.mjs";
import "./index355.mjs";
import "./index356.mjs";
import "react-transition-group";
import "./index357.mjs";
import "./index121.mjs";
import "./index358.mjs";
import "./index359.mjs";
import "./index360.mjs";
import "./index361.mjs";
import "./index362.mjs";
import "./index363.mjs";
import "./index364.mjs";
import "./index124.mjs";
import "emoji-picker-react";
import "./index365.mjs";
import "./index137.mjs";
import "./index366.mjs";
import "./index367.mjs";
import "./index368.mjs";
import "./index369.mjs";
import "./index370.mjs";
import "./index371.mjs";
import "./index372.mjs";
import "./index373.mjs";
import "./index374.mjs";
import "./index375.mjs";
import "./index376.mjs";
import "./index377.mjs";
import "./index378.mjs";
import "recharts";
import "./index379.mjs";
import "./index151.mjs";
import "./index152.mjs";
const B = document.querySelector("body"), j = document.querySelector("html");
function x(r) {
  const m = r ? "add" : "remove";
  B.classList[m](o.no_scroll), j.classList[m](o.no_scroll);
}
const S = ({ className: r, onClick: m, disabled: p, children: _ }) => /* @__PURE__ */ t.createElement(
  "div",
  {
    className: N(o.modal_gallery_navigation, r, {
      [o.modal_gallery_navigation_disabled]: p
    }),
    onClick: m,
    "data-testid": "modal_image_gallery_navigation"
  },
  _
), R = ({ onClick: r, className: m, disabled: p }) => /* @__PURE__ */ t.createElement(S, { className: m, onClick: r, disabled: p }, /* @__PURE__ */ t.createElement(
  h,
  {
    name: "arrows/arrow-left",
    size: "large",
    "data-testid": "modal_image_gallery_left"
  }
)), D = ({ onClick: r, className: m, disabled: p }) => /* @__PURE__ */ t.createElement(S, { className: m, onClick: r, disabled: p }, /* @__PURE__ */ t.createElement(
  h,
  {
    name: "arrows/arrow-right",
    size: "large",
    "data-testid": "modal_image_gallery_right"
  }
)), A = q(
  ({
    items: r,
    isDefaultOpened: m = !1,
    message: p,
    className: _
  }, z) => {
    const [f, b] = g(m), [n, k] = g(!1), [s, I] = g(!1), [e, u] = g(0), C = G(null), y = r[e];
    H(() => {
      k(e === 0), e === r.length - 1 ? I(!0) : I(!1);
    }, [e, r.length]);
    const L = a((i) => {
      b(!0), x(!0), u(i || 0);
    }, []), l = a(() => {
      b(!1), x(!1);
    }, []);
    M(
      z,
      () => ({
        open: L,
        close: l
      }),
      [L, l]
    );
    const c = a(() => {
      if (n)
        return;
      const i = e - 1;
      u(i);
    }, [e, n]), d = a(() => {
      if (s)
        return;
      const i = e + 1;
      u(i);
    }, [e, s]), v = a(
      ({ keyCode: i }) => {
        i === 27 && l(), i === 37 && c(), i === 39 && d();
      },
      [c, l, d]
    ), E = a(
      ({ target: i }) => {
        C.current === i && l();
      },
      [l]
    );
    if (H(() => (f && (document.addEventListener("keydown", v, !1), document.addEventListener("click", E, !1)), () => {
      document.removeEventListener("keydown", v, !1), document.removeEventListener("click", E, !1);
    }), [f, E, v]), !f || !y || !r.length)
      return null;
    const w = (i) => /* @__PURE__ */ t.createElement(
      "div",
      {
        className: N(o.modal_gallery_image_counter, i),
        "data-testid": "modal_gallery_image_counter"
      },
      e + 1,
      " / ",
      r.length
    );
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: C,
        "data-testid": "modal-image-gallery",
        className: N(o.modal_gallery_overlay, _)
      },
      /* @__PURE__ */ t.createElement("div", { className: o.modal_gallery }, /* @__PURE__ */ t.createElement(
        "div",
        {
          className: o.modal_gallery_close,
          onClick: l,
          "data-testid": "modal_image_gallery_close"
        },
        /* @__PURE__ */ t.createElement(h, { name: "actions/close-alt", size: "small" }),
        O.t("booking_engine.close")
      ), /* @__PURE__ */ t.createElement("div", { className: o.modal_gallery_container }, r.length > 1 ? /* @__PURE__ */ t.createElement(
        R,
        {
          onClick: c,
          disabled: n
        }
      ) : null, /* @__PURE__ */ t.createElement("div", { className: o.modal_gallery_image_container }, /* @__PURE__ */ t.createElement(
        "img",
        {
          className: o.modal_gallery_image,
          src: y.url,
          alt: y.alt
        }
      ), p ? /* @__PURE__ */ t.createElement(
        "div",
        {
          "data-testid": "modal_gallery_message",
          className: o.modal_gallery_message
        },
        /* @__PURE__ */ t.createElement("p", null, p)
      ) : null, w()), r.length > 1 ? /* @__PURE__ */ t.createElement(
        D,
        {
          onClick: d,
          disabled: s
        }
      ) : null), /* @__PURE__ */ t.createElement("div", { className: o.modal_gallery_mobile_footer }, r.length > 1 ? /* @__PURE__ */ t.createElement(
        R,
        {
          onClick: c,
          disabled: n
        }
      ) : null, w(o.modal_gallery_mobile_footer_counter), r.length > 1 ? /* @__PURE__ */ t.createElement(
        D,
        {
          onClick: d,
          disabled: s
        }
      ) : null))
    );
  }
);
A.displayName = "ModalImageGallery";
export {
  A as ModalImageGallery,
  A as default
};
